export const environment = {
  production: true,
  API_DOMAINS:{
    servicios: 'https://api-cd-qa.0s.cl/servicios'
  }
};
